
/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 01/03/2025
 * @update 01/03/2025
 * @file src/components/W17/W17F1202
 */

import { Column } from "devextreme-react/data-grid";
import { Button, Checkbox, Col, DatePicker, Dropdown, Row, Typography } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/user-actions";
import * as W17F1202Actions from "../../actions/w17/W17F1202/w17F1202-actions";
import Config from "../../config";
import GridContainer from "../common/grid-container/grid-container";

const FormID = 'W17F1202';

const useStyles = makeStyles((theme) => ({
    ellipsis: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    popAction: {
        minWidth: 196,
        padding: theme.spacing([2, 0, 2, 0])
    },
    btnActionItem: {
        display: 'flex',
        width: '100%',
        justifyContent: 'start',
        color: theme.colors.primary
    },
    btnDownload: {
        position: 'absolute',
        bottom: 0,
        right: 0,
    },
    imageModal: {
        minHeight: 126,
        maxHeight: 570,
        overflowY: 'scroll'
    }
}));

const initialDataMaster = {
    EmployeeID: '',
    GroupSalesID: '',
    DateFrom: null,
    DateTo: null,
};

const W17F1202 = (props) => {
    const classes = useStyles();
    const [iPermission, setIPermission] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [cboEmployeeLoading, setCboEmployeeLoading] = useState(false);
    const [cboGroupSalesLoading, setCboGroupSalesLoading] = useState(false);
    const [dataMaster, setDataMaster] = useState(initialDataMaster);
    const [dataCboEmployee, setDataCboEmployee] = useState([]);
    const [dataCboGroupSales, setDataCboGroupSales] = useState([]);
    const [dynamicCol, setDynamicCol] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);

    const gridRef = useRef(false);
    const gridContainerRef = useRef(false);

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    useEffect(() => {
        if (!iPermission) return;
        getCboEmployee();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataMaster.GroupSalesID]);

    useEffect(() => {
        if (!iPermission) return;
        getCboGroupSales();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataMaster.EmployeeID]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (isPer) => {
            setIPermission(isPer);
        })
    };

    const getCboEmployee = () => {
        const { GroupSalesID = '' } = dataMaster;
        const params = {
            GroupSalesID
        };
        setCboEmployeeLoading(true);
        props.W17F1202Actions.getCboEmployee(params, (error, data) => {
            setCboEmployeeLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboEmployee(data);
            }
        })
    };

    const getCboGroupSales = () => {
        setCboGroupSalesLoading(true);
        props.W17F1202Actions.getCboGroupSales((error, data) => {
            setCboGroupSalesLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboGroupSales(data);
            }
        })
    };

    const loadForm = () => {
        const { DateFrom = null, DateTo = null, EmployeeID = '', GroupSalesID = '' } = dataMaster;
        const params = {
            EmployeeID,
            GroupSalesID,
            DateFrom,
            DateTo,
        };
        setFormLoading(true);
        props.W17F1202Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const { columns = [], rows = [] } = data || {};
                setDynamicCol(columns);
                setDataGrid(rows);
            }
        });
    };

    const onExportExcel = () => {
        const { DateFrom = null, DateTo = null, EmployeeID = '', EmployeeName = '', GroupSalesID = '' } = dataMaster;
        const params = {
            EmployeeID,
            GroupSalesID,
            DateFrom,
            DateTo,
        };
        let line01 = '';
        if (!Config.isEmpty(EmployeeName)) line01 = '-';
        const title = `${Config.lang('Bao_cao_vieng_tham_khach_hang')} ${line01} ${EmployeeName}`;
        Config.exportExcel(params, '/w17f1202/export', title);
    };

    const onView = () => {
        loadForm();
    };

    const onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        let objPlus = { [fieldName]: value };
        if (fieldName === 'EmployeeID') objPlus = { ...objPlus, EmployeeName: e?.data?.EmployeesName || '' };
        else if (['DateFrom', 'DateTo'].includes(fieldName) && Config.isEmpty(value)) objPlus[fieldName] = null;
        setDataMaster({ ...dataMaster, ...objPlus });
    };

    const renderCheckBoxCol = (e) => {
        return <Checkbox
            readOnly
            style={{ margin: 'auto' }}
            className={'display_row align-center'}
            checked={e?.value === 1}
        />;
    };

    const renderMaxWidthColum = (e, maxWidth = 300) => { // default max width 300
        const value = e?.value || '';
        return <div title={value} className={classes.ellipsis}
            {...(Config.typeOf(maxWidth, 'number') ? { style: { maxWidth } } : {})} >{value}</div>
    };

    const handleRenderCol = () => {
        let result = [];
        let parentCol = {};
        let childCol = [];
        for (let i = 0; i < dynamicCol.length; i++) {
            let col = null;
            let objPlus = {};
            let type = 'varchar';
            const { Alignment = 'left', FieldName = '', Caption = '', DataType = '', Visible = true, Width = 150, IsPermanent, GroupID } = dynamicCol[i] || {};
            if (DataType) type = ['decimal', 'varchar', 'int', 'datetime'].find(item => DataType.search(item) > -1);
            switch (type) {
                case 'decimal': // Number
                    objPlus = {
                        alignment: 'right',
                        dataType: 'number'
                    };
                    break;
                case 'varchar': // String
                    objPlus = {
                        alignment: 'left',
                    };
                    break;
                case 'datetime': // Ngày
                    objPlus = {
                        dataType: 'date',
                        alignment: 'center',
                        format: 'dd/MM/yyyy',
                        editorOptions: { placeholder: 'DD/MM/YYYY' }
                    };
                    break;
                case 'int': // CheckBox / Toggle...
                    objPlus = {
                        alignment: 'center',
                        cellRender: (e) => renderCheckBoxCol(e)
                    };
                    break;
                default:
                    break;
            }
            if (IsPermanent === 1) objPlus = { // PIN Cột
                ...objPlus,
                fixed: true,
                visibleIndex: null,
                fixedPosition: 'left',
            };
            if (GroupID === FieldName) {
                col = <Column key={i}
                    dataField={FieldName}
                    caption={Caption}
                    width={Width}
                    alignment={Alignment}
                    visible={Visible}
                    cellRender={(e) => renderMaxWidthColum(e)}
                    {...objPlus}
                />;
            } else if (Config.isEmpty(GroupID)) { // Col Cha
                parentCol = dynamicCol[i] || {};
            } else if (GroupID === parentCol?.FieldName) { // Col Con
                childCol.push(<Column
                    dataField={FieldName}
                    caption={Caption}
                    width={Width}
                    alignment={Alignment}
                    visible={Visible}
                    cellRender={(e) => renderMaxWidthColum(e)}
                    {...objPlus}
                />);
                if (dynamicCol?.[i + 1]?.GroupID !== parentCol?.FieldName) {  // Không còn con thì push mảng 
                    col = <Column key={i} caption={parentCol?.Caption || ''} alignment={'center'} >{childCol.map(item => item)}</Column>
                    parentCol = {}; // Clear value
                    childCol = []; // Clear value
                }
            }
            if (col) result.push(col);
        }
        return result;
    };

    const renderGrid = useMemo(() => {
        let column = [];
        if (!Config.isEmpty(dynamicCol)) column = handleRenderCol(dynamicCol);
        const dataSource = dataGrid.map((item, idx) => ({ ...item, STT: idx }))
        return (
            <GridContainer
                pagerFullScreen
                reference={ref => (gridRef.current = ref)}
                ref={ref => (gridContainerRef.current = ref)}
                dataSource={dataSource}
                isPer={iPermission}
                loading={formLoading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={30}
                height={Config.getHeightGrid() - 122}>
                {column}
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, dynamicCol, formLoading]);

    if (!iPermission) return null;
    return (
        <div className='page-container'>
            <Row>
                <Col xs={12}><Typography color={'info'} type={'h4'}>{Config.lang('Bao_cao_tong_hop')}</Typography></Col>
                <Col xs={12} sm={6} md={4} lg={3} verticalAlign={'end'}>
                    <Dropdown
                        clearAble
                        viewType={'outlined'}
                        valueExpr={'GroupSalesID'}
                        displayExpr={'GroupSalesName'}
                        label={Config.lang('Nhom_nhan_vien')}
                        disabled={formLoading}
                        loading={cboGroupSalesLoading}
                        value={dataMaster?.GroupSalesID}
                        dataSource={dataCboGroupSales || []}
                        onChange={e => onChange('GroupSalesID', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={4} lg={3} verticalAlign={'end'}>
                    <Dropdown
                        clearAble
                        viewType={'outlined'}
                        valueExpr={'EmployeeID'}
                        displayExpr={'EmployeesName'}
                        label={Config.lang('Nhan_vien')}
                        disabled={formLoading}
                        loading={cboEmployeeLoading}
                        value={dataMaster?.EmployeeID}
                        dataSource={dataCboEmployee || []}
                        onChange={e => onChange('EmployeeID', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={4} lg={3}>
                    <Row>
                        <Col xs={6}>
                            <DatePicker
                                clearAble
                                viewType={'outlined'}
                                displayFormat={"DD/MM/YYYY"}
                                label={Config.lang('Tu')}
                                disabled={formLoading}
                                max={dataMaster?.DateTo}
                                value={dataMaster?.DateFrom}
                                onChange={e => onChange('DateFrom', e)}
                            />
                        </Col>
                        <Col xs={6}>
                            <DatePicker
                                clearAble
                                viewType={'outlined'}
                                displayFormat={"DD/MM/YYYY"}
                                label={Config.lang('Den')}
                                disabled={formLoading}
                                min={dataMaster?.DateFrom}
                                value={dataMaster?.DateTo}
                                onChange={e => onChange('DateTo', e)}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3} verticalAlign={'end'}>
                    <Button
                        disabled={formLoading || Permissions < 1}
                        label={Config.lang('Xuat_excel')}
                        viewType={'outlined'}
                        color={'success'}
                        startIcon={'Sheet'}
                        onClick={onExportExcel}
                    />
                    <Button
                        disabled={formLoading || Permissions < 1}
                        label={Config.lang('Xem')}
                        viewType={'filled'}
                        color={'info'}
                        startIcon={'View'}
                        className={'mgl2x'}
                        onClick={onView}
                    />
                </Col>
                <Col xs={12}>{renderGrid}</Col>
            </Row>
        </div>
    );
}

export default connect(null, (dispatch) => ({
    W17F1202Actions: bindActionCreators(W17F1202Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W17F1202);


